import { FirebaseDocumentDataType, FirebaseSnapshotType } from 'firebase/index'
import { ScheduleType } from 'types/schedule'

const mergeSchedules = (snapshots: FirebaseDocumentDataType) => {
  const schedules: ScheduleType[] = []
  snapshots.forEach((snapshot: FirebaseSnapshotType) => {
    const data = snapshot.data() as ScheduleType
    data.schedule_ref = snapshot.ref
    schedules.push(data)
  })
  return schedules
}

export default mergeSchedules
